import { Injectable } from "@angular/core";
import { ActiveState, EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import { Pricelist } from "../../model/pricelist";

export interface PricelistsState extends EntityState<Pricelist, string>, ActiveState<string> { }

@Injectable({ providedIn: "root" })
@StoreConfig({ name: "pricelists" })
export class PricelistsStore extends EntityStore<PricelistsState> {
    constructor() {
        super();
    }
}
